import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const EnergyUtilities = () => {
  return (
    <>
      <SEO 
        title="Energy & Utilities Solutions - Abacies Logiciels"
        description="Optimize energy operations with smart grid solutions, utility management systems, predictive maintenance, and IoT-powered solutions for energy companies and utilities."
        keywords="energy technology, utility management, smart grid solutions, energy analytics, utility software, energy management systems"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Energy & Utilities
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Energy & Utilities page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Energy & Utilities. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default EnergyUtilities;
